<template>
  <div class="muButton">
    <div class="btn border">
      <div class="btn-bar">
        <div class="pill icon" @click="playButton"><font-awesome-icon :icon="playIcon"></font-awesome-icon></div>
        <div class="pill textarea" @click="playPosition">
          <p class="filename">{{vo.filename}}.ogg</p>
          <p class="progress" :style="progress">{{vo.filename}}.ogg</p>
        </div>
        <div class="pill icon" @click="download"><font-awesome-icon icon="cloud-download-alt"></font-awesome-icon></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['vo'],
  data(){
    return {
    }
  },
  computed:{
    playIcon(){return this.vo.playing?'pause-circle':'play-circle'},
    srcfilename(){return this.vo.filename+"."+this.vo.ext},
    progress(){
      var result = {};
      if (this.vo.duration == 0){
        result.width = "0%"
      }else{
        result.width = this.vo.position/this.vo.duration*100+"%";
      }
      return result;
    }
  },
  methods:{
    playButton(){
      this.$emit('playPause');
    },
    playPosition(event){
      this.$emit("playPosition",event.layerX,event.target.offsetWidth)
      },
    download(){
      this.$emit("download");
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.muButton {
  display: block;
  cursor:pointer;
  margin:4px 0px;
  border-radius: 4px;
  height:32px;
}

.btn-bar {
  display:flex;
  justify-content: left;
  flex-wrap: nowrap;
  .pill {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    color: #ff943c;
    &.icon{
      height:32px;
      width:32px;
      &:hover {
        background-image: linear-gradient(to bottom , #fff 50%, #fff3ef 80%, #ffcba1 100%);
      }
    }
    &:first-child{border-radius: 4px 0 0 4px}
    &:last-child{border-radius: 0 4px 4px 0}
    &.textarea{
      flex-grow:1;
      justify-content: flex-start;
      position: relative;
      &:hover{
        .progress{text-shadow: 0px 1px 1px #ffffff;}
        .filename{text-shadow: 0px 0px 1px #ff943c;}
      }
      .progress{
        color:#fff;
        background-color: #ff943c;
        position: absolute;
        left: 0;
        overflow: hidden;
        white-space: nowrap;
      }
      .progress,.filename{
        display: inline-flex;
        height: 100%;
        justify-content: left;
        align-items: center;
      }

    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/muPlay.vue